<template>
  <flexbox align="stretch">
    <flexbox-item style="margin-right: 50px;">
      <div class="area-title">定位</div>
      <el-autocomplete
        v-model="searchInput"
        :fetch-suggestions="querySearchAsync"
        style="width: 100%;"
        placeholder="請輸入詳細位置名稱"
        @blur="inputBlur"
        @focus="inputFocus"
        @select="handleSelect">
        <template slot-scope="{ item }">
          <div class="name">{{ item.address + item.title }}</div>
        </template>
      </el-autocomplete>
      <div
        id="choicemap"
        class="map"/>
      <div class="area-title">詳細地址</div>
      <el-input
        v-model="detail_address"
        placeholder=""/>
    </flexbox-item>
    <flexbox-item>
      <div class="area-title">省/市/區</div>
      <v-distpicker
        :province="addressSelect.province"
        :city="addressSelect.city"
        :area="addressSelect.area"
        @province="selectProvince"
        @city="selectCity"
        @area="selectArea"/>
    </flexbox-item>
  </flexbox>
</template>
<script type="text/javascript">
import VDistpicker from 'v-distpicker'

export default {
  name: 'XhCustomerAddress', // 新建 客戶位置
  components: {
    VDistpicker
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    /** 索引值 用於更新數據 */
    index: Number,
    /** 包含數據源 */
    item: Object
  },
  data() {
    return {
      map: null,
      /** 搜索地圖輸入框 */
      searchInput: '',
      searchCopyInput: '', // 避免修改
      /** 完整地址輸入框 */
      detail_address: '',
      point_address: null, // 經緯度點
      /** 區域選擇 */
      addressSelect: {
        province: '',
        city: '',
        area: ''
      },
      /** 防止聯動情況  */
      canExecute: true
    }
  },
  computed: {},
  watch: {
    point_address: function(newValue) {
      this.valueChange()
    },
    detail_address: function(newValue) {
      this.valueChange()
    }
  },
  mounted() {
    var map = new BMap.Map('choicemap', { enableMapClick: false })
    map.centerAndZoom(new BMap.Point(116.404, 39.915), 14)
    // map.disableDragging() //禁止拖拽
    // map.disableDoubleClickZoom()
    // map.disableScrollWheelZoom()
    // map.disableContinuousZoom()
    map.enableScrollWheelZoom()
    this.map = map
    if (this.value && JSON.stringify(this.value) !== '{}') {
      this.initInfo(this.value)
    } else {
      var geolocation = new BMap.Geolocation()
      var self = this
      geolocation.getCurrentPosition(
        function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            self.addMarkerLabel(r.point)
          }
        },
        { enableHighAccuracy: true }
      )
    }
  },
  methods: {
    initInfo(val) {
      this.searchInput = val.location
      this.detail_address = val.detail_address
      if (Object.prototype.toString.call(val.address) == '[object Array]') {
        var address = {}
        for (let index = 0; index < val.address.length; index++) {
          index === 0 ? (address['province'] = val.address[0]) : ''
          index === 1 ? (address['city'] = val.address[1]) : ''
          index === 2 ? (address['area'] = val.address[2]) : ''
        }
        this.addressSelect = address
      }
      if (val.lng != 0 && val.lat != 0) {
        this.point_address = new BMap.Point(val.lng, val.lat)
        this.addMarkerLabel(this.point_address)
      }
    },
    querySearchAsync(queryString, cb) {
      if (queryString) {
        var options = {
          onSearchComplete: function(results) {
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              var address = []
              for (var i = 0; i < results.getCurrentNumPois(); i++) {
                address.push(results.getPoi(i))
              }
              cb(address)
            } else {
              cb([])
            }
          },
          pageCapacity: 20
        }
        var local = new BMap.LocalSearch(this.map, options)
        local.search(queryString)
      } else {
        cb([])
      }
    },
    /** 搜索結果選擇 */
    handleSelect(item) {
      this.searchInput = item.address + item.title
      this.searchCopyInput = this.searchInput // 只能通過這種方式修改

      this.detail_address = this.searchInput
      this.addMarkerLabel(item.point)
      this.point_address = item.point
      this.mapSelectArea(item)
    },
    /** Input 失去焦點  searchInput 只能通過選擇更改*/
    inputBlur() {
      if (this.searchCopyInput !== this.searchInput) {
        this.searchInput = this.searchCopyInput
      }
    },
    inputFocus() {
      this.searchCopyInput = this.searchInput
    },
    // 建立標註
    addMarkerLabel(point) {
      this.map.clearOverlays()
      this.map.centerAndZoom(point, 14)
      this.map.addOverlay(new BMap.Marker(point))
    },
    /** 區域選擇 */
    selectProvince(value) {
      this.addressSelect.province = value.value
      this.valueChange()
    },
    selectCity(value) {
      this.addressSelect.city = value.value
      this.valueChange()
    },
    selectArea(value) {
      this.addressSelect.area = value.value
      this.valueChange()
    },
    /** 地圖選擇區域 */
    mapSelectArea(data) {
      if (this.canExecute) {
        this.canExecute = false
        /** 因為poi裡面不包含區域 所以需要逆地址解析 */
        var myGeo = new BMap.Geocoder()
        // 根據座標得到地址描述
        var self = this
        myGeo.getLocation(
          new BMap.Point(data.point.lng, data.point.lat),
          function(result) {
            if (result) {
              // 獲取經緯度點
              self.point_address = result.point
              self.addressSelect.province = result.addressComponents.province
                ? result.addressComponents.province
                : ''
              self.addressSelect.city = result.addressComponents.city
                ? result.addressComponents.city
                : ''
              self.addressSelect.area = result.addressComponents.district
                ? result.addressComponents.district
                : ''
            }
          }
        )

        setTimeout(() => {
          self.canExecute = true
        }, 500)
      }
    },
    // 值更新的回撥
    valueChange() {
      this.$emit('value-change', {
        index: this.index,
        value: {
          address: [
            this.addressSelect.province,
            this.addressSelect.city,
            this.addressSelect.area
          ],
          location: this.searchInput,
          detail_address: this.detail_address,
          lat: this.point_address ? this.point_address.lat : '',
          lng: this.point_address ? this.point_address.lng : ''
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.map {
  height: 150px;
  width: 100%;
  overflow: hidden;
  margin-top: 5px;
}

.area-title {
  font-size: 12px;
  color: #aaa;
  padding-left: 10px;
}

.distpicker-address-wrapper::v-deepselect {
  height: 34px;
  font-size: 12px;
  border-radius: 0.1rem;
}
</style>
